import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { supabase } from '../../services/supabaseClient';

const ART_IMG = '/art-design/art.png';
const LOCAL_NOME = 'Av. Vert Ville, 570 — Alphaville';
const DATA_TXT = 'Sábado, 30/05 · A partir das 11h';
const STORAGE_KEY = 'art-design-confirmado';
const ORIGEM = 'art-design-evento';

const Page = styled.div`
  min-height: 100vh;
  background: #050b16;
  color: #ffffff;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 16px 60px;
`;

const Card = styled.div`
  width: 100%;
  max-width: 600px;
  background: #081426;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(0,0,0,.55);
`;

const Hero = styled.div`
  width: 100%;
  aspect-ratio: 600/360;
  background: #07101f center/cover no-repeat url(${ART_IMG});
  border-bottom: 1px solid rgba(212,154,72,.25);
`;

const Body = styled.div`
  padding: 36px 32px 30px;
  @media (max-width: 500px) { padding: 28px 22px 24px; }
`;

const Title = styled.h1`
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-size: 30px;
  font-weight: 300;
  letter-spacing: .6px;
  line-height: 1.2;
  margin: 0 0 18px;
  strong {
    display: block;
    font-weight: 700;
    color: #d49a48;
    font-style: italic;
  }
`;

const Lead = styled.p`
  margin: 0 0 14px;
  font-size: 15.5px;
  line-height: 1.65;
  color: #d8e3f0;
  strong { color: #ffffff; font-weight: 600; }
`;

const InfoBox = styled.div`
  margin: 22px 0 26px;
  border: 1px solid rgba(212,154,72,.55);
  border-radius: 12px;
  padding: 18px 20px;
  background: #07101f;
  display: grid;
  gap: 10px;
`;

const InfoRow = styled.div`
  font-size: 14px;
  color: #ffffff;
  line-height: 1.5;
  span.label {
    color: #d49a48;
    font-size: 11px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    font-weight: 600;
    display: block;
    margin-bottom: 2px;
  }
`;

const Form = styled.form`
  display: grid;
  gap: 14px;
  margin-top: 8px;
`;

const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 10.5px;
  letter-spacing: 1.5px;
  color: #9aa8b8;
  text-transform: uppercase;
  font-weight: 500;
  input {
    background: #050b16;
    border: 1px solid rgba(255,255,255,.12);
    color: #ffffff;
    border-radius: 8px;
    padding: 13px 14px;
    font-size: 15px;
    font-family: inherit;
    letter-spacing: 0;
    text-transform: none;
    font-weight: 400;
    outline: none;
    transition: border-color .15s, box-shadow .15s;
    &::placeholder { color: #596678; }
    &:focus {
      border-color: #d49a48;
      box-shadow: 0 0 0 3px rgba(212,154,72,.15);
    }
  }
`;

const ErrText = styled.div`
  color: #ff8c8c;
  font-size: 12px;
  margin-top: -4px;
`;

const Submit = styled.button`
  margin-top: 8px;
  background: #d49a48;
  color: #081426;
  border: none;
  padding: 15px 22px;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: .6px;
  cursor: pointer;
  font-family: inherit;
  text-transform: uppercase;
  transition: transform .15s, box-shadow .15s, opacity .15s;
  &:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 8px 20px rgba(212,154,72,.35); }
  &:disabled { opacity: .55; cursor: not-allowed; transform: none; box-shadow: none; }
`;

const Footnote = styled.p`
  margin: 18px 0 0;
  font-size: 11px;
  line-height: 1.6;
  color: #9aa8b8;
`;

const Footer = styled.div`
  padding: 22px 30px 28px;
  background: #050b16;
  text-align: center;
  font-size: 11px;
  letter-spacing: .5px;
  color: #596678;
  line-height: 1.6;
  border-top: 1px solid rgba(255,255,255,.05);
`;

// confirmação
const Success = styled.div`
  padding: 60px 32px 50px;
  text-align: center;
  h2 {
    font-family: 'Cormorant Garamond', Georgia, serif;
    font-size: 30px;
    font-weight: 300;
    margin: 0 0 12px;
    color: #ffffff;
    strong { color: #d49a48; font-weight: 700; font-style: italic; }
  }
  p {
    font-size: 15px;
    color: #d8e3f0;
    line-height: 1.6;
    margin: 0 0 8px;
  }
  .check {
    width: 64px; height: 64px;
    border-radius: 50%;
    background: rgba(212,154,72,.18);
    color: #d49a48;
    font-size: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 18px;
  }
`;

function maskPhone(v) {
  const d = (v || '').replace(/\D/g, '').slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 7) return `(${d.slice(0,2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0,2)}) ${d.slice(2,6)}-${d.slice(6)}`;
  return `(${d.slice(0,2)}) ${d.slice(2,7)}-${d.slice(7)}`;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function ArtDesignEventoPage() {
  const [form, setForm] = useState({ nome: '', telefone: '', email: '' });
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(() => {
    if (typeof window === 'undefined') return false;
    return localStorage.getItem(STORAGE_KEY) === '1';
  });

  useEffect(() => {
    document.title = 'Art Design Residence · Fly Experience';
    window.scrollTo(0, 0);
  }, []);

  const set = (k) => (e) => {
    const val = k === 'telefone' ? maskPhone(e.target.value) : e.target.value;
    setForm(f => ({ ...f, [k]: val }));
    setErrors(er => ({ ...er, [k]: undefined }));
  };

  const validate = () => {
    const er = {};
    if (!form.nome.trim() || form.nome.trim().length < 2) er.nome = 'Informe seu nome.';
    const digits = form.telefone.replace(/\D/g, '');
    if (digits.length < 10) er.telefone = 'Telefone inválido.';
    if (!form.email.trim() || !EMAIL_RE.test(form.email.trim())) er.email = 'Email inválido.';
    setErrors(er);
    return Object.keys(er).length === 0;
  };

  const submit = async (e) => {
    e.preventDefault();
    if (sending) return;
    if (!validate()) return;
    setSending(true);
    try {
      const emailLc = form.email.trim().toLowerCase();
      const rawDigits = form.telefone.replace(/\D/g, '');
      // Normaliza pra E.164 BR: prefixa 55 se ainda não estiver (pra wa.me funcionar no WhatsApp Desktop)
      const telefoneDigits = rawDigits.startsWith('55') ? rawDigits : `55${rawDigits}`;

      // Dedup: já existe lead com o mesmo email/telefone pra esse evento?
      const { data: existing } = await supabase
        .from('mf_leads_site')
        .select('id')
        .eq('origem', ORIGEM)
        .or(`email.eq.${emailLc},telefone.eq.${telefoneDigits}`)
        .limit(1);

      if (existing && existing.length > 0) {
        localStorage.setItem(STORAGE_KEY, '1');
        setDone(true);
        return;
      }

      const { data: lead, error } = await supabase
        .from('mf_leads_site')
        .insert({
          nome: form.nome.trim(),
          telefone: telefoneDigits,
          email: emailLc,
          origem: ORIGEM,
        })
        .select('id')
        .single();

      if (error) {
        console.error('[art-design] insert lead', error);
        setErrors({ submit: 'Não conseguimos registrar agora. Tente novamente.' });
        setSending(false);
        return;
      }

      fetch('/api/mf-lead', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ lead_id: lead.id, evento: 'agendamento_evento_art' }),
      }).catch(() => {}); // fire-and-forget

      localStorage.setItem(STORAGE_KEY, '1');
      setDone(true);
    } catch (err) {
      console.error('[art-design] submit', err);
      setErrors({ submit: 'Erro inesperado. Tente novamente.' });
      setSending(false);
    }
  };

  return (
    <Page>
      <Card>
        <Hero role="img" aria-label="Art Design Residence — Fly Experience" />

        {done ? (
          <Success>
            <div className="check">✓</div>
            <h2>Presença <strong>confirmada.</strong></h2>
            <p>Em breve nossa equipe entra em contato para confirmar detalhes da experiência.</p>
            <p style={{ marginTop: 18, fontSize: 13, color: '#9aa8b8' }}>
              {DATA_TXT}<br />{LOCAL_NOME}
            </p>
          </Success>
        ) : (
          <Body>
            <Title>
              Nova data confirmada.
              <strong>A Fly Experience volta neste sábado.</strong>
            </Title>

            <Lead>
              A pedidos, abrimos uma <strong>nova data exclusiva</strong> para
              você conhecer o <strong>Art Design Residence</strong> de um ângulo
              que poucos vão ter. Além do{' '}
              <strong>voo panorâmico de helicóptero sobre Alphaville</strong>,
              desta vez preparamos algo a mais: uma{' '}
              <strong>degustação exclusiva com Isabela Akkari</strong>,
              referência em confeitaria saudável. Vagas limitadas, por ordem de chegada.
            </Lead>

            <InfoBox>
              <InfoRow>
                <span className="label">Local</span>
                {LOCAL_NOME}
              </InfoRow>
              <InfoRow>
                <span className="label">Data e horário</span>
                {DATA_TXT}
              </InfoRow>
            </InfoBox>

            <Form onSubmit={submit} noValidate>
              <Field>
                Nome
                <input
                  type="text"
                  autoComplete="name"
                  placeholder="Seu nome completo"
                  value={form.nome}
                  onChange={set('nome')}
                  disabled={sending}
                />
                {errors.nome && <ErrText>{errors.nome}</ErrText>}
              </Field>

              <Field>
                Telefone
                <input
                  type="tel"
                  inputMode="numeric"
                  autoComplete="tel"
                  placeholder="(11) 99999-9999"
                  value={form.telefone}
                  onChange={set('telefone')}
                  disabled={sending}
                />
                {errors.telefone && <ErrText>{errors.telefone}</ErrText>}
              </Field>

              <Field>
                Email
                <input
                  type="email"
                  autoComplete="email"
                  placeholder="seu@email.com"
                  value={form.email}
                  onChange={set('email')}
                  disabled={sending}
                />
                {errors.email && <ErrText>{errors.email}</ErrText>}
              </Field>

              {errors.submit && <ErrText>{errors.submit}</ErrText>}

              <Submit type="submit" disabled={sending}>
                {sending ? 'Enviando...' : 'Garantir minha vaga'}
              </Submit>
            </Form>

            <Footnote>
              *Experiências sujeitas à disponibilidade operacional, condições climáticas e dinâmica do evento.
            </Footnote>
          </Body>
        )}

        <Footer>
          Art Design Residence — Alphaville<br />
          Imagens meramente ilustrativas. Consulte condições comerciais e disponibilidade com a equipe responsável.
        </Footer>
      </Card>
    </Page>
  );
}
